import { LAStorageCalculator } from './ui/lastoragecalculator';
import { calcAppReducer } from './actions/calcreducer';
import { initialState } from './state/calculatorstate';
import { Context } from './context';

import { useReducer } from 'react';

import './ui/styling/actionsizecontainer.css';
import './ui/styling/advancedoptions.css';
import './ui/styling/browseworkflow.css';
import './ui/styling/calculatorconfigcontainer.css';
import './ui/styling/calculatoroutputcontainer.css';
import './ui/styling/costoutputtable.css';
import './ui/styling/lastoragecalculator.css';
import './ui/styling/monthlyrunscontrol.css';
import './ui/styling/outputinfosection.css';
import './ui/styling/repeatingactionsloops.css';

import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';

function App() {
    const [state, dispatch] = useReducer(calcAppReducer, initialState);

    initializeIcons();
    return (
        <Context.Provider value={{ state, dispatch }}>
            <LAStorageCalculator />
        </Context.Provider>
    );
}

export default App;
